/* Poseidon Equipment: behaviour for the poseidon-* sections.
   Performance rules:
   - one rAF loop, fed by passive scroll listeners; it only WRITES transform/opacity. Every layout read
     (offsets, sizes) happens in measure(), which runs on load, resize and font load, never per frame.
   - reveals use IntersectionObserver; everything shows at once under reduced motion or in the theme editor.
   - mega menu and phone menu photos are not rendered until the page is idle ("armed").
   Horizon scrolls .page-wrapper on desktop (>= 990px) and the document on phones; scroller() handles both.
   Re-initialises a section when the theme editor reloads it. */
(function () {
  'use strict';
  var D = document, W = window, H = D.documentElement;
  var $ = function (s, e) { return (e || D).querySelector(s); };
  var $$ = function (s, e) { return Array.prototype.slice.call((e || D).querySelectorAll(s)); };
  var reduced = W.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = W.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var SQ = W.matchMedia('(min-width: 990px)');
  var design = !!(W.Shopify && W.Shopify.designMode);
  /* If this script arrives after the CSS failsafe has already shown everything, skip the reveal animations. */
  var late = !!(W.performance && performance.now() > 2800);
  var vw = W.innerWidth, vh = W.innerHeight, sc = null;

  function scroller() {
    var pw = $('.page-wrapper');
    if (SQ.matches && pw && pw.scrollHeight > pw.clientHeight + 1 && getComputedStyle(pw).overflowY !== 'visible') return pw;
    return D.scrollingElement || H;
  }
  function sy() { return (sc || (sc = scroller())).scrollTop; }
  function absTop(el) { return el.getBoundingClientRect().top + sy(); }
  function onIdle(fn, t) { if (W.requestIdleCallback) W.requestIdleCallback(fn, { timeout: t || 2000 }); else setTimeout(fn, 400); }

  /* ---------- one rAF loop ---------- */
  var mods = [], ticking = false;
  function request() { if (!ticking) { ticking = true; W.requestAnimationFrame(frame); } }
  function frame() { ticking = false; var y = sy(); for (var i = 0; i < mods.length; i++) if (mods[i].update) mods[i].update(y); }
  function measure() {
    sc = scroller(); vw = W.innerWidth; vh = W.innerHeight;
    for (var i = 0; i < mods.length; i++) if (mods[i].measure) mods[i].measure();
    request();
  }
  function add(m) { mods.push(m); if (m.measure) m.measure(); request(); }
  D.addEventListener('scroll', request, { passive: true, capture: true });
  var rt, lastW = vw;
  W.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () { if (!fine && W.innerWidth === lastW) { vh = W.innerHeight; request(); return; } lastW = W.innerWidth; measure(); }, 150);
  }, { passive: true });
  W.addEventListener('load', measure);
  if (D.fonts && D.fonts.ready) D.fonts.ready.then(measure);

  /* ---------- reveals ---------- */
  var io = ('IntersectionObserver' in W) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('pz-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  function reveals(root) {
    $$('.pz-rv,[data-pz-rv-img],[data-pz-wipe]', root).forEach(function (n) {
      if (!io || reduced || design || late) n.classList.add('pz-in'); else io.observe(n);
    });
  }

  /* ---------- announcement: messages fade out, then the next fades in ---------- */
  function initAnnc(el) {
    var msgs = $$('.pz-annc-msg', el), i = 0, paused = false;
    if (msgs.length < 2 || reduced) return;
    el.addEventListener('mouseenter', function () { paused = true; });
    el.addEventListener('mouseleave', function () { paused = false; });
    el.__timer = setInterval(function () {
      if (paused || D.hidden) return;
      msgs[i].classList.remove('pz-on'); i = (i + 1) % msgs.length; msgs[i].classList.add('pz-on');
    }, 5000);
  }

  /* ---------- header ---------- */
  function initHeader(hdr) {
    var sec = hdr.parentNode, scrim = $('[data-pz-scrim]', sec), sheet = $('.pz-sheet', sec), burger = $('[data-pz-burger]', hdr);
    var acctBtn = $('[data-pz-acct-btn]', hdr), acctPop = $('#pz-acct-pop', hdr);
    var sBtn = $('[data-pz-search-btn]', hdr), sPanel = $('#pz-search', hdr), q = $('[data-pz-q]', hdr), res = $('[data-pz-qres]', hdr), idle = $('[data-pz-qidle]', hdr);
    var dock = $('[data-pz-dock]', sec);
    var megas = $$('[data-pz-mega]', hdr);
    var armed = false;

    /* menus render their photos only once armed: on first intent, or when the page goes idle */
    /* desktop: the mega menus render (and fetch their photos) once the page is idle, so they are ready before the first hover.
       phone: the menu sheet renders on first touch of the menu button; its photos load right after it opens. */
    var WIDE = W.matchMedia('(min-width: 1081px)'), sheetArmed = false;
    function arm() { if (armed) return; armed = true; hdr.classList.add('pz-armed'); }
    function armSheet() { if (sheetArmed || !sheet) return; sheetArmed = true; sheet.classList.add('pz-armed'); }
    W.addEventListener('load', function () { onIdle(function () { if (WIDE.matches) arm(); }, 3000); });
    var nav = $('.pz-nav', hdr);
    if (nav) { nav.addEventListener('pointerenter', arm, { once: true }); nav.addEventListener('focusin', arm, { once: true }); }
    if (burger) { burger.addEventListener('pointerdown', armSheet, { once: true }); burger.addEventListener('focus', armSheet, { once: true }); }
    function afterArm(fn) { if (armed) return fn(); arm(); W.requestAnimationFrame(function () { W.requestAnimationFrame(fn); }); }
    function afterSheet(fn) { if (sheetArmed) return W.requestAnimationFrame(fn); armSheet(); W.requestAnimationFrame(function () { W.requestAnimationFrame(fn); }); }

    function isOpen(m) { return m.classList.contains('pz-open'); }
    function setMega(m, on) { m.classList.toggle('pz-open', on); $('[data-pz-mega-btn]', m).setAttribute('aria-expanded', on ? 'true' : 'false'); }
    function closeMegas(except) { megas.forEach(function (m) { if (m !== except && isOpen(m)) setMega(m, false); }); }
    function closePops() {
      if (acctPop && acctPop.classList.contains('pz-open')) { acctPop.classList.remove('pz-open'); acctBtn.setAttribute('aria-expanded', 'false'); }
      if (sPanel && sPanel.classList.contains('pz-open')) { sPanel.classList.remove('pz-open'); sBtn.setAttribute('aria-expanded', 'false'); }
    }
    function sync() {
      var mega = megas.some(isOpen), s = sPanel && sPanel.classList.contains('pz-open'), a = acctPop && acctPop.classList.contains('pz-open');
      if (scrim) scrim.classList.toggle('pz-on', mega || s || a);
      hdr.classList.toggle('pz-menu-open', mega || s);
    }
    function lock(on) { if (on) H.setAttribute('scroll-lock', ''); else H.removeAttribute('scroll-lock'); H.style.overflow = on ? 'hidden' : ''; }
    function closeSheet(refocus) {
      if (!sheet || !sheet.classList.contains('pz-open')) return;
      sheet.classList.remove('pz-open'); if (burger) burger.setAttribute('aria-expanded', 'false');
      lock(false);
      if (refocus && burger) burger.focus();
    }
    function closeAll() { closeMegas(); closePops(); closeSheet(); sync(); }

    if (scrim) scrim.addEventListener('click', closeAll);
    D.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openMega = megas.filter(isOpen)[0], searchOpen = sPanel && sPanel.classList.contains('pz-open'), acctOpen = acctPop && acctPop.classList.contains('pz-open');
      var sheetOpen = sheet && sheet.classList.contains('pz-open');
      if (!openMega && !searchOpen && !acctOpen && !sheetOpen) return;
      closeAll();
      if (sheetOpen && burger) burger.focus();
      else if (openMega) $('[data-pz-mega-btn]', openMega).focus();
      else if (searchOpen && sBtn) sBtn.focus();
      else if (acctOpen && acctBtn) acctBtn.focus();
    });
    /* outside click (for clicks inside the header bar but outside the open panel) */
    D.addEventListener('click', function (e) {
      if (!hdr.classList.contains('pz-menu-open') && !(acctPop && acctPop.classList.contains('pz-open'))) return;
      var t = e.target;
      if (megas.some(function (m) { return isOpen(m) && m.contains(t); })) return;
      if ((sPanel && sPanel.contains(t)) || (sBtn && sBtn.contains(t)) || (acctPop && acctPop.contains(t)) || (acctBtn && acctBtn.contains(t))) return;
      closeAll();
    });

    megas.forEach(function (item) {
      var btn = $('[data-pz-mega-btn]', item), panel = $('.pz-mega', item), t;
      function open(focusFirst) {
        afterArm(function () {
          closePops(); closeMegas(item); setMega(item, true); sync();
          if (focusFirst) { var a = $('a', panel); if (a) setTimeout(function () { a.focus(); }, 30); }
        });
      }
      function close() { setMega(item, false); sync(); }
      btn.addEventListener('click', function () { isOpen(item) ? close() : open(false); });
      btn.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown') { e.preventDefault(); open(true); } });
      item.addEventListener('focusout', function (e) { if (isOpen(item) && e.relatedTarget && !item.contains(e.relatedTarget)) close(); });
      if (fine) {
        item.addEventListener('mouseenter', function () { clearTimeout(t); t = setTimeout(function () { open(false); }, megas.some(isOpen) ? 0 : 80); });
        item.addEventListener('mouseleave', function () { clearTimeout(t); t = setTimeout(close, 160); });
      }
    });

    if (acctBtn && acctPop) acctBtn.addEventListener('click', function (e) {
      e.stopPropagation(); var o = !acctPop.classList.contains('pz-open'); closeMegas(); closePops();
      if (o) { acctPop.classList.add('pz-open'); acctBtn.setAttribute('aria-expanded', 'true'); }
      sync();
    });

    /* search: Shopify predictive search (/search/suggest.json) */
    if (sBtn && sPanel) {
      sBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var o = !sPanel.classList.contains('pz-open'); closeMegas(); closePops(); closeSheet();
        if (o) { sPanel.classList.add('pz-open'); sBtn.setAttribute('aria-expanded', 'true'); setTimeout(function () { if (q) q.focus({ preventScroll: true }); }, 40); }
        sync();
      });
      var xClose = $('[data-pz-search-close]', hdr); if (xClose) xClose.addEventListener('click', function () { closePops(); sync(); sBtn.focus(); });
      var st, ctrl, base = (res && res.getAttribute('data-suggest')) || '/search/suggest';
      var money = function (v) { var n = Number(v); if (isNaN(n)) return String(v); return '$' + n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }); };
      /* R7: never show $0. Merged products can hold unpriced $0 variants (held at 0 stock), so the suggest API's price
         can read 0. Show "From" when the price range differs; when the low end is 0, fetch the product and use the
         cheapest available variant priced above $0 (fillPrices below), showing "See options" until then. */
      var priceLabel = function (p) {
        /* R10: products tagged coming-soon are listed before they are priced; 30 Sept: call-for-price are sold at the shop */
        if ((p.tags || []).indexOf('call-for-price') > -1) return 'Call or text for price';
        if ((p.tags || []).indexOf('coming-soon') > -1) return 'Coming soon';
        var lo = +p.price_min || +p.price || 0, hi = +p.price_max || 0;
        if (lo > 0) return (hi > lo ? 'From ' : '') + money(lo);
        return hi > 0 ? 'See options' : 'Product';
      };
      var fillPrices = function (root) {
        root.querySelectorAll('[data-pz-price]').forEach(function (el) {
          var h = el.getAttribute('data-pz-price'); el.removeAttribute('data-pz-price');
          fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
            if (!j || !j.variants) return;
            var vs = j.variants.filter(function (v) { return v.available && v.price > 0; });
            if (!vs.length) return;
            var ps = vs.map(function (v) { return v.price; });
            var lo = Math.min.apply(null, ps), hi = Math.max.apply(null, ps);
            /* match the cards: a cheapest price sold by the foot reads "/ ft" */
            var perFt = vs.filter(function (v) { return v.price === lo; }).every(function (v) { return /by the foot|per ft/i.test(v.title || ''); });
            el.textContent = (hi > lo ? 'From ' : '') + money(lo / 100) + (perFt ? ' / ft' : '');
          }).catch(function () {});
        });
      };
      var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
      /* R12: "Suggested" categories at the top of the dropdown. The header lists every menu collection with the words
         shoppers use for it (data-pz-cats). A category matches when the search contains one of its words, or a
         search word of 3+ letters starts one of its words or title words ("noz" -> Nozzles & Tips, "jrod" -> J-Rods). */
      var cats = [];
      try { var cj = $('[data-pz-cats]', hdr); if (cj) cats = JSON.parse(cj.textContent) || []; } catch (e) { cats = []; }
      var norm = function (x) { return ' ' + String(x || '').toLowerCase().replace(/[^a-z0-9./\s-]+/g, ' ').replace(/\s+/g, ' ').trim() + ' '; };
      cats.forEach(function (c) {
        c.w = String(c.k || '').split(',').map(function (w) { return w.trim().toLowerCase(); }).filter(Boolean);
        c.tw = norm(c.t).trim().split(' ').filter(function (w) { return w.length > 2; });
      });
      var suggest = function (v) {
        var qn = norm(v), qw = qn.trim().split(' ').filter(Boolean), out = [];
        cats.forEach(function (c) {
          /* each search word scores once per category: 3 (+1 per extra word) for a whole search word, 2 for a prefix */
          var sc = 0, got = {};
          c.w.forEach(function (w) {
            if (qn.indexOf(' ' + w + ' ') > -1) { if (!got[w]) { got[w] = 1; sc += 2 + w.split(' ').length; } }
            /* a partial word only counts against single category words: "hose" must not pull in "hose barb" (Fittings) */
            else if (w.length > 2 && w.indexOf(' ') < 0) qw.forEach(function (x) { if (x.length > 2 && w.indexOf(x) === 0 && !got['~' + x]) { got['~' + x] = 1; sc += 2; } });
          });
          c.tw.forEach(function (w) { qw.forEach(function (x) { if (x.length > 2 && w.indexOf(x) === 0 && !got['~' + x]) { got['~' + x] = 1; sc += 2; } }); });
          if (sc) out.push({ c: c, s: sc });
        });
        out.sort(function (a, b) { return (b.s - a.s) || (b.c.n - a.c.n); });
        return out.slice(0, 3).map(function (x) { return x.c; });
      };
      var run = function () {
        var v = q.value.trim(); if (idle) idle.hidden = !!v;
        if (!v) { res.innerHTML = ''; return; }
        if (ctrl) ctrl.abort(); ctrl = ('AbortController' in W) ? new AbortController() : null;
        fetch(base + '.json?q=' + encodeURIComponent(v) + '&resources[type]=product,collection,page&resources[limit]=8&resources[options][unavailable_products]=show', ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var R = (d.resources && d.resources.results) || {}, out = [];
            /* R10: sold-out parts still go last, but coming-soon products (listed before they are priced, never
               in stock) keep their place by relevance instead of dropping off the end of the list */
            var soon = function (p) { var t = p.tags || []; return t.indexOf('coming-soon') > -1 || t.indexOf('call-for-price') > -1; };
            var ps = R.products || [];
            ps = ps.filter(function (p) { return p.available !== false || soon(p); }).concat(ps.filter(function (p) { return p.available === false && !soon(p); }));
            /* R12: Shopify also returns "similar" products for words it does not know ("zzqq" lists trailers). When no
               product shares a word of the search (first 5 letters, like snippets/pz-search-match), do not list them. */
            var keys = norm(v).trim().split(' ').filter(function (w) { return w && (w.length > 1 || /\d/.test(w)) && !/^(the|and|for|with|in|a|an|of|to|or|on)$/.test(w); }).map(function (w) { return w.slice(0, 5); });
            var weak = keys.length && ps.length && !ps.some(function (p) {
              var hay = norm([p.title, p.type, p.vendor].concat(p.tags || []).join(' '));
              return keys.some(function (k) { return hay.indexOf(k) > -1; });
            });
            if (weak) ps = [];
            ps.forEach(function (p) { out.push('<li><a href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(p.image + (String(p.image).indexOf('?') > -1 ? '&' : '?') + 'width=96') + '" alt="" width="44" height="44" loading="lazy">' : '<span class="pz-noimg"><svg class="pz-icon" aria-hidden="true"><use href="#pz-i-cube"/></svg></span>') + '<span>' + esc(p.title) + '</span><small' + ((+p.price > 0 && !(+p.price_max > +p.price_min)) || soon(p) ? '' : ' data-pz-price="' + esc(p.handle) + '"') + '>' + esc(priceLabel(p)) + '</small></a></li>'); });
            (R.pages || []).forEach(function (p) { out.push('<li><a href="' + esc(p.url) + '"><span>' + esc(p.title) + '</span><small>Page</small></a></li>'); });
            /* R12: matching categories go first, as a "Suggested" row (the menu categories matched by their search
               words, plus any collection Shopify's own suggest returned) */
            var sg = suggest(v), sgu = {}, path = function (x) { return String(x || '').split('?')[0]; };
            sg.forEach(function (c) { sgu[path(c.u)] = 1; });
            (R.collections || []).forEach(function (c) { if (!sgu[path(c.url)] && sg.length < 4) { sgu[path(c.url)] = 1; sg.push({ t: c.title, u: c.url, n: 0 }); } });
            if (sg.length) {
              out.unshift('<li class="pz-sg"><span class="pz-sg-label" id="pz-sg-label">Suggested</span><span class="pz-sg-list" role="group" aria-labelledby="pz-sg-label">' + sg.map(function (c) {
                return '<a class="pz-sg-chip" href="' + esc(c.u) + '"><span>' + esc(c.t) + '</span>' + (c.n ? '<small>' + c.n + (c.n === 1 ? ' part' : ' parts') + '</small>' : '<small>Category</small>') + '</a>';
              }).join('') + '</span></li>');
            }
            /* R10: sizes like "3/8" or "24 in" match more parts than the 8 shown here: always offer the full results.
               R12: with the same options as the search form (coming soon parts rank by relevance, not last) */
            if (out.length || weak) {
              var fAct = (q.form && q.form.getAttribute('action')) || '/search';
              out.push('<li style="grid-column:1/-1"><a href="' + esc(fAct + '?q=' + encodeURIComponent(v) + '&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=show') + '"><span>See all results for &ldquo;' + esc(v) + '&rdquo;</span><small>Search</small></a></li>');
            }
            if (weak) out.splice(sg.length ? 1 : 0, 0, '<li class="pz-empty">No exact match for &ldquo;' + esc(v) + '&rdquo;. Check the spelling, try a shorter word or a category, or call (501) 503-2623.</li>');
            res.innerHTML = out.length ? out.join('') : '<li class="pz-empty">No match yet. Press Enter to search everything.</li>';
            fillPrices(res);
          })
          .catch(function () {});
      };
      if (q) q.addEventListener('input', function () { clearTimeout(st); st = setTimeout(run, 150); });
      $$('[data-pz-qfill]', hdr).forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); q.value = a.getAttribute('data-pz-qfill'); run(); q.focus(); }); });
    }

    /* phone sheet */
    if (sheet && burger) {
      burger.addEventListener('click', function () {
        closePops(); closeMegas(); sync();
        afterSheet(function () {
          sheet.classList.add('pz-open'); burger.setAttribute('aria-expanded', 'true'); lock(true);
          setTimeout(function () {
            var c = $('[data-pz-sheet-close]', sheet); if (c) c.focus({ preventScroll: true });
            /* photos in the closed accordions: fetch them now, while the menu is being read */
            $$('img[loading="lazy"]', sheet).forEach(function (im) { im.loading = 'eager'; });
          }, 600);
        });
      });
      var sc2 = $('[data-pz-sheet-close]', sheet); if (sc2) sc2.addEventListener('click', function () { closeSheet(true); });
      $$('a', sheet).forEach(function (a) { a.addEventListener('click', function () { closeSheet(false); }); });
      $$('.pz-acc-btn', sheet).forEach(function (b) { b.addEventListener('click', function () { var acc = b.parentNode, o = !acc.classList.contains('pz-open'); acc.classList.toggle('pz-open', o); b.setAttribute('aria-expanded', o ? 'true' : 'false'); }); });
      /* keep Tab inside the open sheet */
      sheet.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var f = $$('a[href],button:not([disabled])', sheet).filter(function (x) { return x.offsetParent !== null; });
        if (!f.length) return; var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && D.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && D.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }

    /* cart count: Horizon fires shopify:cart:lines-update with a promise that resolves to the new cart */
    var count = $('[data-pz-cart-count]', hdr), cartLink = $('[data-pz-cart]', hdr);
    function renderCount(n) {
      if (!count || n == null || isNaN(n)) return;
      var was = parseInt(count.textContent, 10) || 0;
      count.textContent = n > 99 ? '99+' : n; count.hidden = !n;
      if (cartLink) cartLink.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
      if (n > was && !reduced) { count.classList.remove('pz-bump'); void count.offsetWidth; count.classList.add('pz-bump'); }
    }
    function refreshCart() {
      fetch((W.Shopify && W.Shopify.routes ? W.Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); }).then(function (c) { renderCount(c.item_count); }).catch(function () {});
    }
    function onCart(e) {
      var p = e && e.promise;
      if (p && p.then) p.then(function (r) { var c = r && r.cart, d = r && r.detail; var n = c && c.totalQuantity != null ? c.totalQuantity : (d && d.itemCount); if (n != null) renderCount(n); else refreshCart(); }, refreshCart);
      else refreshCart();
    }
    ['shopify:cart:lines-update', 'cart:update', 'cart:updated'].forEach(function (n) { D.addEventListener(n, onCart); });
    W.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });

    /* solid on scroll + phone dock */
    var footIn = false, foot = $('.pz-foot'), solid = null, dockOn = null;
    if (dock && foot && io) new IntersectionObserver(function (es) { footIn = es[0].isIntersecting; request(); }).observe(foot);
    add({ el: hdr, update: function (y) {
      var s = y > 8; if (s !== solid) { solid = s; hdr.classList.toggle('pz-solid', s); }
      if (dock) { var d = y > vh * 0.7 && !footIn; if (d !== dockOn) { dockOn = d; dock.classList.toggle('pz-on', d); } }
    } });
  }

  /* ---------- hero ---------- */
  function initHero(hero) {
    var copy = $('[data-pz-par-copy]', hero), rig = $('[data-pz-par-rig]', hero), h1 = $('h1', hero), img = $('.pz-rig', hero);
    var px = 0, py = 0, tx = 0, ty = 0, top = 0, h = 0, on = true;
    /* the inline script in the hero normally does this first; this is the fallback */
    hero.classList.add('pz-go');
    function loaded() { hero.classList.add('pz-loaded'); }
    if (design || !img || img.tagName !== 'IMG' || img.complete) loaded(); else { img.addEventListener('load', loaded); img.addEventListener('error', loaded); setTimeout(loaded, 2500); }
    /* the rig's width is solved in CSS (see .pz-hero-stage), so nothing here resizes it after first paint */
    if (fine && !reduced) hero.addEventListener('pointermove', function (e) { px = (e.clientX / vw - 0.5) * 2; py = (e.clientY / vh - 0.5) * 2; request(); }, { passive: true });
    add({
      el: hero,
      measure: function () { top = absTop(hero); h = hero.offsetHeight; },
      update: function (y) {
        if (reduced) return;
        var s = y - top;
        if (s > h * 1.05) { if (on) { on = false; } return; }
        on = true; s = Math.max(0, s);
        var k = Math.min(1, s / h);
        tx += (px - tx) * 0.08; ty += (py - ty) * 0.08;
        copy.style.transform = 'translate3d(' + (-tx * 6).toFixed(2) + 'px,' + (s * 0.22 - ty * 4).toFixed(2) + 'px,0)';
        copy.style.opacity = Math.max(0, 1 - k * 1.1).toFixed(3);
        if (rig && vw > 767) rig.style.transform = 'translate3d(' + (tx * 12).toFixed(2) + 'px,' + (s * 0.1 + ty * 6).toFixed(2) + 'px,0) scale(' + (1 + k * 0.04).toFixed(4) + ')';
        if (Math.abs(px - tx) > 0.002 || Math.abs(py - ty) > 0.002) request();
      }
    });
  }

  /* ---------- signature builds: pinned sideways scroll on desktop, swipe on touch ---------- */
  function initBuilds(sec) {
    var track = $('[data-pz-track]', sec), cards = $$('[data-pz-card]', sec), prog = $('[data-pz-prog]', sec), cnt = $('[data-pz-count]', sec);
    if (!track || !cards.length) return;
    var imgs = cards.map(function (c) { return c.querySelector('.pz-bcard-img img'); });
    var total = cnt ? cnt.getAttribute('data-total') : '05', n = parseInt(total, 10) || cards.length;
    var pinned = false, top = 0, dist = 0, x = 0, base = [], half = [], lastP = -1, lastI = -1, sl = 0, maxSl = 0;
    var pv = $('[data-pz-prev]', sec), nx = $('[data-pz-next]', sec);
    function step(dir) {
      var w = base.length > 1 ? base[1] - base[0] : cards[0].offsetWidth + 20;
      if (pinned) { var s = sy(); sc.scrollTo({ top: Math.max(top, Math.min(top + dist, s + dir * w)), behavior: reduced ? 'auto' : 'smooth' }); }
      else track.scrollBy({ left: dir * w, behavior: reduced ? 'auto' : 'smooth' });
    }
    if (pv) pv.addEventListener('click', function () { step(-1); });
    if (nx) nx.addEventListener('click', function () { step(1); });
    /* scroll position is read in the scroll event (clean layout), never inside the rAF write pass */
    track.addEventListener('scroll', function () { sl = track.scrollLeft; request(); }, { passive: true });
    add({
      el: sec,
      measure: function () {
        var want = vw >= 1024 && vh >= 720 && fine && !reduced && !design;
        if (want !== pinned) { pinned = want; sec.classList.toggle('pz-pinned', pinned); if (!pinned) { sec.style.height = ''; track.style.transform = ''; } }
        track.style.transform = ''; x = 0;
        var tl = track.getBoundingClientRect().left, sl = pinned ? 0 : track.scrollLeft;
        base = cards.map(function (c) { return c.getBoundingClientRect().left - tl + sl; });
        half = cards.map(function (c) { return c.offsetWidth / 2; });
        base.tl = tl;
        if (pinned) {
          /* only pin when the whole block fits below the header with some air; otherwise fall back to swipe */
          var head = $('.pz-sec-head', sec), note = $('.pz-hs-note', sec) || track;
          var need = note.getBoundingClientRect().bottom - head.getBoundingClientRect().top;
          var hh = parseFloat(getComputedStyle(H).getPropertyValue('--pz-hdr-h')) || 72;
          if (need + hh + 96 > vh) { pinned = false; sec.classList.remove('pz-pinned'); sec.style.height = ''; base = cards.map(function (c) { return c.getBoundingClientRect().left - tl + track.scrollLeft; }); }
        }
        if (pinned) { dist = Math.max(0, track.scrollWidth - track.clientWidth); sec.style.height = (vh + dist) + 'px'; top = absTop(sec); }
        sl = track.scrollLeft; maxSl = track.scrollWidth - track.clientWidth;
        lastP = -1;
      },
      update: function (y) {
        var p;
        if (pinned && dist) { p = Math.min(1, Math.max(0, (y - top) / dist)); x = -p * dist; track.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)'; }
        else { p = maxSl > 0 ? Math.min(1, sl / maxSl) : 0; }
        if (Math.abs(p - lastP) < 0.0005) return; lastP = p;
        if (prog) prog.style.transform = 'scaleX(' + p.toFixed(3) + ')';
        var i = Math.min(n, Math.round(p * (cards.length - 1)) + 1);
        if (cnt && i !== lastI) { lastI = i; cnt.textContent = ('0' + i).slice(-2) + ' / ' + total; }
        if (pv) pv.disabled = p < 0.01; if (nx) nx.disabled = p > 0.99;
        if (reduced) return;
        for (var k = 0; k < cards.length; k++) {
          var c = (base.tl || 0) + base[k] + half[k] + (pinned ? x : -sl);
          if (c < -half[k] * 2 || c > vw + half[k] * 2 || !imgs[k]) continue;
          imgs[k].style.setProperty('--px', (((c - vw / 2) / vw) * -24).toFixed(1) + 'px');
        }
      }
    });
  }

  /* ---------- product rail (featured parts): arrows follow the native scroll ---------- */
  function initRail(sec) {
    var track = $('[data-pz-rail]', sec), pv = $('[data-pz-prev]', sec), nx = $('[data-pz-next]', sec);
    if (!track) return;
    var item = function () { var c = track.children[0]; return c ? c.offsetWidth + parseFloat(getComputedStyle(track).columnGap || 12) : 300; };
    if (pv) pv.addEventListener('click', function () { track.scrollBy({ left: -item() * 2, behavior: reduced ? 'auto' : 'smooth' }); });
    if (nx) nx.addEventListener('click', function () { track.scrollBy({ left: item() * 2, behavior: reduced ? 'auto' : 'smooth' }); });
    var t;
    function state() { var m = track.scrollWidth - track.clientWidth; if (pv) pv.disabled = track.scrollLeft < 4; if (nx) nx.disabled = track.scrollLeft > m - 4; sec.classList.toggle('pz-rail-static', m < 4); }
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(state, 60); }, { passive: true });
    add({ el: sec, measure: state });
  }

  /* ---------- build your rig: platform picker ---------- */
  function initByr(sec) {
    var out = $('[data-pz-plat-out]', sec), chips = $$('.pz-pchip', sec);
    if (!out || !chips.length) return;
    var esc = function (s) { var d = D.createElement('div'); d.textContent = s || ''; return d.innerHTML; };
    function set(btn) {
      chips.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      var rev = btn.getAttribute('data-status') === 'review';
      out.innerHTML = '<b>' + esc(btn.getAttribute('data-name')) + '</b><span class="pz-status' + (rev ? ' pz-rev' : '') + '">' + esc(out.getAttribute(rev ? 'data-rev' : 'data-std')) + '</span><p>' + esc(btn.getAttribute('data-text')) + '</p>';
    }
    chips.forEach(function (b) { b.addEventListener('click', function () { set(b); }); });
    set(chips.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || chips[0]);
  }

  /* ---------- faq: one open at a time ---------- */
  function initFaq(sec) {
    var ds = $$('details', sec);
    ds.forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) ds.forEach(function (o) { if (o !== d) o.open = false; }); }); });
  }

  /* ---------- v2: ambient loops (waves, marquees) run only while on screen ---------- */
  var liveIO = ('IntersectionObserver' in W) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { e.target.classList.toggle('pz-live', e.isIntersecting); });
  }, { rootMargin: '80px 0px' }) : null;
  function ambient(root) {
    if (reduced || !liveIO) return;
    $$('[data-pz-waves],[data-pz-marq]', root).forEach(function (n) { if (!n.__pzLive) { n.__pzLive = true; liveIO.observe(n); } });
  }

  /* ---------- v2: pointer effects (desktop, fine pointer only): spotlight, 3D tilt, magnetic buttons ----------
     One delegated pointermove listener and one rAF write. Reads (getBoundingClientRect) happen before the writes in the same frame,
     and only transforms and opacity are written. */
  var SPOT = '.pz-card,.pz-ctile,.pz-bcard,.pz-dopt,.pz-pcard-link,.pzs-card,.pzs-rcard,.pzs-rig,.pzs-hub-tile,.pzs-dopt,.pzs-rmore-card,.pzs-rdel-card,.pzs-rspec-card,.pzp-grid .pz-card,.content-for-layout .product-card,[data-pz-spot]';
  var TILT = '[data-pz-tilt]', MAG = '.pz-btn-primary,[data-pz-mag]';
  function pointerFx() {
    if (!fine || reduced || design) return;
    var cur = { spot: null, tilt: null, mag: null }, mx = 0, my = 0, queued = false, quietUntil = 0;
    var now = function () { return W.performance ? performance.now() : Date.now(); };
    function spotOn(h) {
      if (!h.__pzSpot) {
        var c = D.createElement('span'), s = D.createElement('span'); c.className = 'pz-spot-clip'; s.className = 'pz-spot'; c.setAttribute('aria-hidden', 'true');
        c.appendChild(s); h.appendChild(c); h.__pzSpot = s; h.classList.add('pz-spot-host'); if (getComputedStyle(h).position === 'static') h.style.position = 'relative';
      }
      h.classList.add('pz-spot-on');
    }
    function tiltOn(h) {
      if (!h.__pzSheen) { var s = D.createElement('span'); s.className = 'pz-sheen'; s.setAttribute('aria-hidden', 'true'); s.appendChild(D.createElement('i')); h.appendChild(s); h.__pzSheen = s; }
      /* measure once, untilted: reading the rect of a tilted card every frame fed the tilt back into itself */
      h.__pzRect = h.getBoundingClientRect();
      h.classList.add('pz-tilt', 'pz-tilting');
    }
    function off(kind, h) {
      if (!h) return;
      if (kind === 'spot') h.classList.remove('pz-spot-on');
      if (kind === 'tilt') { h.classList.remove('pz-tilting'); h.style.transform = ''; h.__pzRect = null; }
      if (kind === 'mag') { h.style.transform = ''; h.__pzRect = null; }
    }
    function write() {
      queued = false; var r, x, y;
      if (cur.spot && cur.spot.__pzSpot) { r = cur.spot.getBoundingClientRect(); cur.spot.__pzSpot.style.transform = 'translate3d(' + (mx - r.left).toFixed(1) + 'px,' + (my - r.top).toFixed(1) + 'px,0)'; }
      if (cur.tilt) {
        r = cur.tilt.__pzRect || cur.tilt.getBoundingClientRect(); x = (mx - r.left) / r.width; y = (my - r.top) / r.height;
        var mxd = parseFloat(cur.tilt.getAttribute('data-pz-tilt')) || 5;
        cur.tilt.style.transform = 'perspective(1100px) rotateX(' + ((0.5 - y) * mxd).toFixed(2) + 'deg) rotateY(' + ((x - 0.5) * mxd * 1.2).toFixed(2) + 'deg) translate3d(0,-2px,0)';
        if (cur.tilt.__pzSheen) cur.tilt.__pzSheen.firstChild.style.transform = 'translate3d(' + (x * 190 - 40).toFixed(1) + '%,0,0) skewX(-14deg)';
      }
      if (cur.mag) {
        r = cur.mag.__pzRect || (cur.mag.__pzRect = cur.mag.getBoundingClientRect()); x = (mx - r.left) / r.width - 0.5; y = (my - r.top) / r.height - 0.5;
        cur.mag.style.transform = 'translate3d(' + (x * 12).toFixed(1) + 'px,' + (y * 9).toFixed(1) + 'px,0)';
      }
    }
    function track(kind, sel, t, on) {
      var h = t && t.closest ? t.closest(sel) : null;
      if (h !== cur[kind]) { off(kind, cur[kind]); cur[kind] = h; if (h && on) on(h); }
    }
    D.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      /* while the page (or a row) is scrolling, and briefly after, the pointer effects stay off: content moving under a still cursor must not re-trigger them */
      if (now() < quietUntil) return;
      var t = e.target; mx = e.clientX; my = e.clientY;
      track('spot', SPOT, t, spotOn);
      track('tilt', TILT, t, tiltOn);
      track('mag', MAG, t, function (h) { h.classList.add('pz-mag'); });
      if ((cur.spot || cur.tilt || cur.mag) && !queued) { queued = true; W.requestAnimationFrame(write); }
    }, { passive: true });
    function clear() { ['spot', 'tilt', 'mag'].forEach(function (k) { off(k, cur[k]); cur[k] = null; }); }
    D.addEventListener('pointerout', function (e) { if (!e.relatedTarget) clear(); }, { passive: true });
    D.addEventListener('scroll', function () { quietUntil = now() + 220; if (cur.tilt || cur.mag || cur.spot) clear(); }, { passive: true, capture: true });
  }
  pointerFx();

  /* the footer's big faded logo is a CSS mask image: armed once the page is idle, so it never competes with the first screen */
  var idleDone = false;
  function armMarks(root) { $$('.pz-foot-mark-fill', root).forEach(function (n) { n.classList.add('pz-armed'); }); }
  W.addEventListener('load', function () { onIdle(function () { idleDone = true; armMarks(D); }, 3000); });

  var inits = { annc: initAnnc, header: initHeader, hero: initHero, builds: initBuilds, byr: initByr, faq: initFaq, rail: initRail };
  function initAll(root) {
    if (idleDone || design) armMarks(root);
    $$('[data-pz]', root).forEach(function (el) {
      if (el.__pzInit) return; el.__pzInit = true;
      var f = inits[el.getAttribute('data-pz')]; if (f) try { f(el); } catch (e) { if (W.console) console.warn('poseidon', e); }
    });
    reveals(root); ambient(root); measure();
    H.classList.add('pz-ready');
  }
  D.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  D.addEventListener('shopify:section:unload', function (e) {
    mods = mods.filter(function (m) { return !e.target.contains(m.el); });
    $$('[data-pz]', e.target).forEach(function (el) { if (el.__timer) clearInterval(el.__timer); });
  });
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { initAll(D); }); else initAll(D);
})();
